import React from 'react';

export default function RecordsMessage({selectedPage, records, totalCount}) {
    const recordsPerPage = 10;

    const startRecordIndex = (selectedPage - 1) * recordsPerPage + 1;
    const endCount = Math.min(selectedPage * recordsPerPage, totalCount);

    const message = totalCount === 0? `No ${records} found!`: `Showing ${startRecordIndex} to ${endCount} of ${totalCount} ${records}`;

    return <div className="showing">{totalCount===0? <></> : message}</div>;
}